import { Input, Modal } from 'antd';

const levelName = (level) => (level === 3 ? '子节' : level === 2 ? '小节' : '章节');

/** 编辑 / 添加章节弹窗（章 / 节 / 子节） */
export default function EditChapterModal({ editModal, setEditModal, onOk }) {
    const name = levelName(editModal.level);
    const update = (patch) =>
        setEditModal((prev) => ({ ...prev, data: { ...prev.data, ...patch } }));

    return (
        <Modal
            title={editModal.type === 'edit' ? `编辑${name}` : `添加${name}`}
            open={editModal.visible}
            onOk={onOk}
            onCancel={() => setEditModal({ visible: false, type: '', level: 1, data: null })}
            okText="保存"
            cancelText="取消"
            destroyOnHidden
        >
            <div style={{ marginBottom: 16 }}>
                <div style={{ marginBottom: 8, fontWeight: 500 }}>{name}标题</div>
                <Input
                    placeholder={`请输入${name}标题`}
                    maxLength={100}
                    value={editModal.data?.chapter || ''}
                    onChange={(e) => update({ chapter: e.target.value })}
                    onPressEnter={onOk}
                />
            </div>
            <div>
                <div style={{ marginBottom: 8, fontWeight: 500 }}>{name}描述（可选）</div>
                <Input.TextArea
                    placeholder="请输入该章节的主要内容描述"
                    rows={3}
                    maxLength={500}
                    value={editModal.data?.chapterAbstract || ''}
                    onChange={(e) => update({ chapterAbstract: e.target.value })}
                />
            </div>
        </Modal>
    );
}
